export { default } from './ClosableImage'


// WEBPACK FOOTER //
// ./src/components/Image/ClosableImage/index.js